
import analytics from '~/utils/analytics/index.js'
export default defineNuxtPlugin((nuxtApp) => {

       
         //------------- Facebook: page view -------------//
        nuxtApp.provide('PageView', (data) => { 
            analytics('PageView', data)
        })

        //------------- Register GTAG -------------//
        nuxtApp.provide('registerGtag', (data) => { 
            analytics('registerGtag', data)
        })

        // inject trigerTT(eventName, data)
        nuxtApp.provide('trigerTTViewContent', (eventName, data) => {
            analytics(eventName, data)
        })

        //------------- Social media GTAG -------------//
        nuxtApp.provide('socialGtag', (status) => { 
            analytics('socialGtag', status)
        })

        //------------- newsletter GTAG -------------//
        nuxtApp.provide('newsletterGtag', () => { 
            analytics('newsletterGtag', false)
        })

        //------------- cyo choose setting GTAG -------------//
        nuxtApp.provide('choosesettingGtag', (moduleSubType) => { 
            analytics('choosesettingGtag', moduleSubType)
        })

        //------------- cyo select setting GTAG -------------//
        nuxtApp.provide('selectsettingGtag', (moduleSubType) => { 
            analytics('selectsettingGtag', moduleSubType) 
        })

        //------------- cyo choose diamond GTAG -------------//
        nuxtApp.provide('choosediamondGtag', (moduleSubType) => { 
            analytics('choosediamondGtag', moduleSubType) 
        })

        //------------- cyo select diamond GTAG -------------//
        nuxtApp.provide('selectdiamondGtag', (moduleSubType) => { 
            analytics('selectdiamondGtag', moduleSubType) 
        })

        //------------- cyo complete page  GTAG -------------//
        nuxtApp.provide('loadcompleteGtag', (moduleSubType) => { 
            analytics('loadcompleteGtag', moduleSubType) 
        })

        //------------- cyo add to cart  GTAG -------------//
        nuxtApp.provide('cyotoCartGtag', (moduleSubType, data) => { 
            analytics('cyotoCartGtag', {'moduleSubType': moduleSubType, ...data}) 
        })

    
        //------------- loose diamond impression GTAG -------------//
        nuxtApp.provide('looseImpressionGtag', (data) => { 
            analytics('looseImpressionGtag', data) 
        })

        //------------- view loose diamond GTAG -------------//
        nuxtApp.provide('looseViewGtag', (data) => {
            analytics('looseViewGtag', data)  
        })

        //-------------  loose diamond to cart GTAG -------------//
        nuxtApp.provide('loosetoCartGtag', (data) => { 
            analytics('loosetoCartGtag', data) 
        })

        //-------------  loose diamond to cart GTAG -------------//
        nuxtApp.provide('appointmentInitiateGtag', () => { 
            analytics('appointmentInitiateGtag', false) 
        })

        //-------------  loose diamond to cart GTAG -------------//
        nuxtApp.provide('appointmentCreationGtag', () => { 
            analytics('appointmentCreationGtag', false) 
        })

        //-------------  loose diamond to cart GTAG -------------//
        nuxtApp.provide('appointmentSucessGtag', () => { 
            analytics('appointmentSucessGtag', false) 
        })

        //-------------  remove from cart GTAG -------------//
        nuxtApp.provide('removefromCartGtag', (item) => { 
            analytics('removefromCartGtag', item) 
        })

        //-------------  checkout address GTAG -------------//
        nuxtApp.provide('addressGtag', (data) => { 
            analytics('addressGtag', data)
        })

        nuxtApp.provide('submitAddressGtag', (data) => { 
            analytics('submitAddressGtag', data)
        })

        //-------------  checkout payment GTAG -------------//
        nuxtApp.provide('paymentGtag', (data) => { 
            analytics('paymentGtag', data)
        })

        //-------------  checkout payment type GTAG -------------//
        nuxtApp.provide('paymentTypeGtag', (pay_type) => { 
            analytics('paymentTypeGtag', pay_type)
        })

        //-------------  checkout payment success GTAG -------------//
        nuxtApp.provide('paymentSuccessGtag', (data, trans_id) => { 
            analytics('paymentSuccessGtag', {'trans_id': trans_id, ...data})
        })

        nuxtApp.provide('jewelryImpressionGtag', (data) => { 
            if(! (data && data.length) ){

                return
            }
            analytics('jewelryImpressionGtag', data)
        })

        nuxtApp.provide('selectJewelryGtag', (data) => { 
            analytics('selectJewelryGtag', data)
        })

        nuxtApp.provide('jewelryDetailGtag', (data) => { 
            analytics('jewelryDetailGtag', data)
        })

        nuxtApp.provide('jewelryToCartGtag', (data) => { 
            analytics('jewelryToCartGtag', data)
        })

        nuxtApp.provide('presetDetailGtag', (data) => { 
            analytics('presetDetailGtag', data)
        })

        nuxtApp.provide('presetToCartGtag', (data) => { 
            analytics('presetToCartGtag', data)
        })

        nuxtApp.provide('bandDetailGtag', (data) => { 
            analytics('bandDetailGtag', data)
        })

        nuxtApp.provide('bandToCartGtag', (data) => { 
            analytics('bandToCartGtag', data)
        })
        //-------------  cart page GTAG -------------//
        nuxtApp.provide('viewCartGtag', (data) => { 
            analytics('viewCartGtag', data)
        })

   
});

  